// Types
import { StopInterface } from '../stops/types';
import { CarInterface } from '../fleet/types';

/*
 * Action Types
 */
export enum SynopticTypes {
  LIST_SYNOPTIC_REQUEST = '@synoptic/LIST_SYNOPTIC_REQUEST',
  LIST_SYNOPTIC_SUCCESS = '@synoptic/LIST_SYNOPTIC_SUCCESS',
  LIST_SYNOPTIC_FAILURE = '@synoptic/LIST_SYNOPTIC_FAILURE',
}

/*
 * Data types
 */
export interface SynopticLineSectionsInterface {
  id: string;
  name: string;
  description: string;
  minVelocity: number;
  maxVelocity: number;
  way: number;
  stops: Array<{
    id: string;
    lineId: string;
    stopId: string;
    lineSectionId: string;
    order: number;
    way: number;
    busStop: boolean;
    busTurn: boolean;
    createdAt: string;
    updatedAt: string;
    Stop: StopInterface;
  }>;
  cars: Array<CarInterface>;
}

export interface SynopticInterface {
  [line: string]: {
    model: number;
    minVelocity: number;
    maxVelocity: number;
    lineId: string;
    lineSections: Array<SynopticLineSectionsInterface>;
  };
}

/*
 * State type
 */
export interface SynopticState {
  readonly monitoringList: SynopticInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
